import { render, staticRenderFns } from "./ResumenSection.vue?vue&type=template&id=0a693362&scoped=true&"
import script from "./ResumenSection.vue?vue&type=script&lang=js&"
export * from "./ResumenSection.vue?vue&type=script&lang=js&"
import style0 from "./ResumenSection.vue?vue&type=style&index=0&id=0a693362&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a693362",
  null
  
)

export default component.exports